function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "beer",
  transform: "translate(0.1 0.1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7525",
  "data-name": "Grupo 7525",
  transform: "translate(9.46 17.751)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7524",
  "data-name": "Grupo 7524"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_39",
  "data-name": "Trazado 39",
  d: "M276.393,451.29a.393.393,0,1,0,.393.393A.393.393,0,0,0,276.393,451.29Z",
  transform: "translate(-276 -451.29)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7527",
  "data-name": "Grupo 7527",
  transform: "translate(3.933 7.878)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7526",
  "data-name": "Grupo 7526"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_40",
  "data-name": "Trazado 40",
  d: "M135.893,200.29a.393.393,0,0,0-.393.393V208.2a.393.393,0,0,0,.787,0v-7.513A.393.393,0,0,0,135.893,200.29Z",
  transform: "translate(-135.5 -200.29)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7529",
  "data-name": "Grupo 7529",
  transform: "translate(7.08 7.878)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7528",
  "data-name": "Grupo 7528"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_41",
  "data-name": "Trazado 41",
  d: "M215.893,200.29a.393.393,0,0,0-.393.393V208.2a.393.393,0,0,0,.787,0v-7.513A.393.393,0,0,0,215.893,200.29Z",
  transform: "translate(-215.5 -200.29)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7531",
  "data-name": "Grupo 7531",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7530",
  "data-name": "Grupo 7530"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_42",
  "data-name": "Trazado 42",
  d: "M50.88,6.333H48.913V5.143a1.96,1.96,0,0,0-.75-3.484,1.988,1.988,0,0,0-1.129.081A1.97,1.97,0,0,0,45.373.826a1.941,1.941,0,0,0-.742.146,3.52,3.52,0,0,0-5.376.624A3.548,3.548,0,0,0,35.5,5.125v4.72a1.191,1.191,0,0,0,1.2,1.18,1.179,1.179,0,0,0,.413-.074v7.222a1.969,1.969,0,0,0,1.967,1.967h7.867a1.969,1.969,0,0,0,1.967-1.967v-1.18H50.88a1.969,1.969,0,0,0,1.967-1.967V8.3A1.969,1.969,0,0,0,50.88,6.333ZM48.126,17.779h-1.2a.391.391,0,1,0,0,.783h1.132a1.185,1.185,0,0,1-1.112.791H39.079a1.182,1.182,0,0,1-1.112-.787H43.78a.393.393,0,1,0,0-.787H37.9V7.061A2.731,2.731,0,0,0,39.95,5.546a.291.291,0,0,1,.209.082,2.36,2.36,0,0,0,3.351-.043.13.13,0,0,1,.093-.039c.612,0,1.013.131,1.191.389a1.32,1.32,0,0,1,.146.745V8.272a1.182,1.182,0,0,0,.787,1.112v6.4a.393.393,0,1,0,.787,0v-6.4A1.182,1.182,0,0,0,47.3,8.272V5.5a2.087,2.087,0,0,0,.826,0ZM47.085,4.6a.393.393,0,0,0-.572.351V8.272a.393.393,0,0,1-.787,0V6.68a2,2,0,0,0-.286-1.192A2.09,2.09,0,0,0,43.6,4.759a.92.92,0,0,0-.659.279,1.573,1.573,0,0,1-2.234.028,1.077,1.077,0,0,0-.76-.307.79.79,0,0,0-.706.441A1.949,1.949,0,0,1,37.5,6.3a.393.393,0,0,0-.39.393V9.826a.425.425,0,0,1-.413.412.409.409,0,0,1-.413-.393V5.125a2.76,2.76,0,0,1,2.769-2.748,2.806,2.806,0,0,1,.357.023.393.393,0,0,0,.393-.2,2.737,2.737,0,0,1,4.453-.486.393.393,0,0,0,.5.07,1.139,1.139,0,0,1,.61-.174,1.181,1.181,0,0,1,1.114.789.393.393,0,0,0,.59.2,1.18,1.18,0,0,1,1.8.7A1.209,1.209,0,0,1,47.085,4.6Zm1.828,4.093h1.573v5.939H48.913Zm3.147,6.333a1.181,1.181,0,0,1-1.18,1.18H48.913v-.787H50.88a.393.393,0,0,0,.393-.393V8.3a.393.393,0,0,0-.393-.393H48.913V7.119H50.88A1.181,1.181,0,0,1,52.06,8.3Z",
  transform: "translate(-35.5)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))));

function SvgBeer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.546,
    height: 20.339,
    viewBox: "0 0 17.546 20.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeer);
export default __webpack_public_path__ + "static/media/beer.207fcd87.svg";
export { ForwardRef as ReactComponent };